import React from 'react';
import Default from 'layouts/Default';
import Home from './Home';

const NoMatch = props => (
	<Default>
		<Home />
	</Default>
);

export default NoMatch;
